import { default as BSTooltip } from 'bootstrap/js/dist/tooltip';
import { BlockError } from '@/blocks.04-project/block-error/block-error';
import set from 'lodash-es/set';

/***
 * Класс тултипа
 * Доступные параметры https://getbootstrap.com/docs/5.3/components/tooltips/#options
 * @example
 *
 * Кастомные параметры:
 * data-closest {boolean, default: false}  - поиск контейнера по ближайшему родителю
 * data-close-on-blur {boolean, default: false} - закрыть тултип при потери фокуса
 * data-tooltip-reference {string, default: ''} - селектор элемента относительно которого нужно позиционировать tooltip
 */
class Tooltip {
  /***
   * Конструктор тултипа
   * @param elem {HTMLElement} - DOM элемент с data-bs-toggle="tooltip"
   * @param options {Object} -Объект параметров
   */
  constructor(elem, options = null) {
    this.BlockError = new BlockError({ blockName: 'Tooltip', destroy: this.destroy });
    if (!elem) return this.BlockError.error('Отсутствует elem');

    this.block = elem;
    this.block.Tooltip = this;
    this.propOptions = options;

    this.init();
  }

  init = () => {
    this.getOptions();

    this.tooltip = new BSTooltip(this.block, {
      container: this.options.closest ?
        this.block.closest(this.options.container) || this.options.container :
        this.options.container,
      popperConfig: (defaultBsPopperConfig) => {
        return {
          ...defaultBsPopperConfig,
          placement: this.options.placement
        };
      },
      ...this.propOptions
    });

    if (this.options.reference) this.block.addEventListener('inserted.bs.tooltip', this.updateReference);
    if (this.isCloseOnBlur) this.block.addEventListener('blur', this.hideTooltip);

    this.block.classList.add('tooltip_inited');
  };

  hideTooltip = () => this.tooltip.hide();

  updateReference = () => {
    const reference = this.options.closest ? this.block.closest(this.options.reference) : document.querySelector(this.options.reference);

    // Самый стабильный вариант изменения референса. Через modifiers не корректно рассчитывала начальную позицию
    setTimeout(() => {
      set(this.tooltip, '_popper.state.elements.reference', reference || this.block);
      this.tooltip.update();
    }, 0);
  };

  getOptions = () => {
    this.isCloseOnBlur = this.block.hasAttribute('data-close-on-blur');
    this.options = {
      closest: this.block.hasAttribute('data-closest'),
      container: this.block.dataset['bsContainer'] || 'body',
      placement: this.block.dataset['bsPlacement'] || '',
      reference: this.block.dataset['tooltipReference'] || '',
    };
  };

  destroy = () => {
    if (this.tooltip) this.tooltip.dispose();
    if (this.block) {
      if (this.options.reference) this.block.removeEventListener('inserted.bs.tooltip', this.updateReference);
      if (this.isCloseOnBlur) this.block.removeEventListener('blur', this.hideTooltip);
      this.block.classList.remove('tooltip_inited');
      delete this.block.Tooltip;
    }
  };

  static init(container = document) {
    Array.from(container.querySelectorAll('[data-bs-toggle="tooltip"]:not(.tooltip_inited)')).forEach((elem) => new Tooltip(elem));
  }
}

document.addEventListener('DOMContentLoaded', () => Tooltip.init());

// Наш класс tooltip
window.Block.Tooltip = Tooltip;

// Класс tooltip от bootstrap
window.bootstrap.Tooltip = BSTooltip;
